'use strict';

var React = require('react');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var component$1 = require('../Text/component.js');
var index = require('../Flex/index.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const DropdownItem = React.forwardRef(({ disabled, icon, children, role = 'button', tabIndex = 0, ...props }, ref) => (React__default.default.createElement(styles.Styled.Item, { ...props, as: index.Flex.Row, space: "s", ref: ref, tabIndex: tabIndex, role: role, disabled: disabled },
    icon && React__default.default.createElement(component.Icon, { name: icon }),
    React__default.default.createElement(component$1.Text, { variant: "caption" }, children))));

exports.DropdownItem = DropdownItem;
//# sourceMappingURL=Item.js.map
